// extracted by mini-css-extract-plugin
export default {"first":"#0a4d28","productTextBody":"Porecze_productTextBody__Cz1p7","green":"Porecze_green__+2bUM"};